import cityData from './cityData.json';

export const climateZones = Object.values(cityData.states).reduce((acc, state) => {
  Object.entries(state.cities).forEach(([city, data]) => {
    acc[city] = data.climateZone;
  });
  return acc;
}, {});

export const getClimateZone = (city) => {
  return climateZones[city] || "";
}; 